/**
 * Stable CSS class names for E2E — Product search page.
 */
export const PS = {
    page: 'product-search-page',
    breadcrumbSection: 'product-search-page__breadcrumb-section',
    loadingSection: 'product-search-page__loading-section',

    resultsSection: 'product-search-page__results-section',
    resultCard: 'product-search-page__result-card',
    resultCardLayout: 'product-search-page__result-card-layout',

    imageTooltipWrap: 'product-search-page__image-tooltip-wrap',
    imageThumbWrap: 'product-search-page__image-thumb-wrap',
    imageThumb: 'product-search-page__image-thumb',
    imageTooltipImg: 'product-search-page__image-tooltip-img',

    tableWrap: 'product-search-page__table-wrap',
    table: 'product-search-page__table',
    tableHead: 'product-search-page__table-head',
    tableHeadRow: 'product-search-page__table-head-row',
    tableBody: 'product-search-page__table-body',
    tableBodyRow: 'product-search-page__table-body-row',

    cellSpecialColor: 'product-search-page__cell-special-color',
    cellProductName: 'product-search-page__cell-product-name',
    cellGender: 'product-search-page__cell-gender',
    cellCategory: 'product-search-page__cell-category',
    cellStock: 'product-search-page__cell-stock',
    cellActions: 'product-search-page__cell-actions',

    stockIconSuccess: 'product-search-page__stock-icon--success',
    stockIconError: 'product-search-page__stock-icon--error',
    stockText: 'product-search-page__stock-text',

    detailLink: 'product-search-page-input--link-detail',
    detailButton: 'product-search-page-input--button-detail',

    emptyState: 'product-search-page__empty-state',
    emptyNoRecord: 'product-search-page__empty-no-record',
    searchControls: 'product-search-page__search-controls',
    searchPaper: 'product-search-page__search-paper',
    searchSelect: 'product-search-page-input--select-search-type',
    searchInput: 'product-search-page-input--text-search',
    searchButton: 'product-search-page-input--button-search',

    batchSection: 'product-search-page__batch-section',
    batchButton: 'product-search-page-input--button-batch-search',
} as const;

export const PS_BS = {
    modalRoot: 'product-search-batch-modal',
    modalPaper: 'product-search-batch-modal__paper',
    modalTitle: 'product-search-batch-modal__title',
    modalCloseButton: 'product-search-batch-modal-input--button-close',
    modalCloseIcon: 'product-search-batch-modal__close-icon',
    modalBody: 'product-search-batch-modal__body',
    modalTextField: 'product-search-batch-modal-input--text-values',
} as const;

export const psCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

